<template></template>
<script>
import { serviceQuestShareDetail } from '../../service/getData'
export default {
  created() {
    this.requestServiceQuest()
  },
  methods: {
    async requestServiceQuest() {
      let res = await serviceQuestShareDetail('e49rnrN9NY')
      if (res.data.mp_comment_url) {
        window.location.href = res.data.mp_comment_url
      }
    },
  },
}
</script>
